import { render, staticRenderFns } from "./Calendar_component.vue?vue&type=template&id=45841f2c&scoped=true&"
import script from "../assets/js/calendar.js?vue&type=script&lang=js&"
export * from "../assets/js/calendar.js?vue&type=script&lang=js&"
import style0 from "./Calendar_component.vue?vue&type=style&index=0&id=45841f2c&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./Calendar_component.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45841f2c",
  null
  
)

export default component.exports